import type { FC } from 'react';

import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import { PartRegion } from '@/features/storefront/parts/PartRegion';
import type { ProductViewProps } from '@/features/storefront/layouts/product/types';

/**
 * Today's page: image left, everything else right.
 *
 * The columns are this theme's; what stands in them is the merchant's. See
 * `parts/PartRegion.tsx` - the two regions below are where their component tree
 * is drawn, and the presentation this theme wants for those components is in
 * `theme.tsx` beside the grid it wants for these columns.
 */
export const Product: FC<ProductViewProps> = () => (
  <StorefrontContainer className="grid gap-12 py-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]">
    <PartRegion name="gallery" />
    <PartRegion name="main" className="min-w-0" />
  </StorefrontContainer>
);
